export default function ErrorNotice({ title, description }: { title: string; description: string }) {
  return (
    <div className='flex flex-col gap-1'>
      <h2 className='text-base text-red-700 font-bold'>{title}</h2>
      <p className='text-base text-red-700 '>{description}</p>
    </div>
  )
}
